import React, { FC }     from 'react';
import { Button }        from '@material-ui/core';
import { CloudDownload } from '@material-ui/icons';

interface IProps {
  onClick: () => Promise<void>;
}

export const StatisticsTableButton: FC<IProps> = ({ onClick }) => (
  <Button
    variant   = "text"
    color     = "secondary"
    startIcon = {<CloudDownload />}
    onClick   = {onClick}
  >
    Download as Excel
  </Button>
);
